import { Component, OnInit } from '@angular/core';
import { ThemeList, ThemeService } from '@core/services/theme';

// declare const particlesJS: any;

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
@Component({
  standalone: true,
  selector: 'app-theme-change',

  imports: [FormsModule, TranslateModule, NzSwitchModule],
  templateUrl: './theme-change.component.html',
  styleUrls: ['./theme-change.component.less'],
})
export class ThemeChangeComponent implements OnInit {
  constructor(private themeService: ThemeService) {}

  isDarkTheme = true;

  ngOnInit(): void {
    const theme = this.themeService.storedTheme;
    this.isDarkTheme = theme === ThemeList.NIQDark;
    // this.initParticles();
  }

 /* initParticles() {
    const config = this.isDarkTheme ? 'dark':'light';
    particlesJS.load('particles-js', `assets/particles/particles-${config}.json`, function() {
      console.log('callback - particles.js config loaded');
    });
  }*/

  switchTheme(): void {
    this.isDarkTheme = !this.isDarkTheme;
    const theme = this.isDarkTheme ? ThemeList.NIQDark : ThemeList.NIQLight;
    this.themeService.setTheme(theme);
    // this.initParticles();
  }
}
